import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import portalApi from "@/lib/portalApi";
import { HardHat, LogOut, Loader2 } from "lucide-react";

const INTER = { fontFamily: "'Inter', system-ui, sans-serif" };

export default function PortalShell() {
  const navigate = useNavigate();
  const [me, setMe] = useState(null);

  useEffect(() => {
    const t = localStorage.getItem("fl_portal_token");
    if (!t) { navigate("/portal", { replace: true }); return; }
    portalApi.get("/portal/me")
      .then((r) => setMe(r.data))
      .catch(() => {
        localStorage.removeItem("fl_portal_token");
        navigate("/portal", { replace: true });
      });
  }, [navigate]);

  const logout = () => {
    localStorage.removeItem("fl_portal_token");
    navigate("/portal", { replace: true });
  };

  if (!me) {
    return (
      <div className="min-h-screen bg-[#F6F7F9] flex items-center justify-center" style={INTER}>
        <Loader2 className="w-6 h-6 animate-spin text-zinc-400" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F6F7F9]" style={INTER} data-testid="portal-shell">
      <header className="bg-white border-b border-zinc-200 sticky top-0 z-20">
        <div className="max-w-3xl mx-auto px-4 h-16 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2.5 min-w-0">
            <span className="w-9 h-9 rounded-xl bg-[#FF5F15] flex items-center justify-center shrink-0">
              <HardHat className="w-4.5 h-4.5 text-white w-5 h-5" />
            </span>
            <div className="min-w-0">
              <div className="font-extrabold tracking-tight text-zinc-900 leading-none truncate">{me.org?.name}</div>
              <div className="text-[11px] text-zinc-400 font-medium mt-0.5">Client portal</div>
            </div>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <div className="text-sm font-semibold text-zinc-700 hidden sm:block" data-testid="portal-client-name">{me.client?.name}</div>
            <button onClick={logout} className="w-9 h-9 rounded-lg border border-zinc-200 flex items-center justify-center text-zinc-500 hover:text-zinc-900 hover:border-zinc-300 transition-colors" aria-label="Sign out" data-testid="portal-logout">
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-6 pb-16">
        <Outlet context={me} />
      </main>
    </div>
  );
}
